import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FileUploader } from "react-drag-drop-files";
import Draggable from 'react-draggable';
import ReactTimePicker from 'react-time-picker';
import { FetchAutoCompleteData, FileUploadChild } from './CustomHooks';
import { CommonApiData, autoCompleteDelay } from './EnvConfig';
import { GetSession } from 'session-manager-beta';
import PopupWithIcon from './Popups';

export const FormButton = (props) => {
    let { handleSubmit, handleExport, handleClear, handleSearch, id = null, search = false, searchText = 'Search', inputrefs, children, save = true, Export = true, update = false, Reset = true, saveicon = null, savetext = 'Save' } = props
    return (
        <div className='d-block d-md-flex' >
            <div className="">
                {search &&
                    <button type="button" name={id}
                        onClick={handleSearch}
                        ref={ref => (inputrefs ? inputrefs.current[id] = ref : null)}
                        className="btn btn-rounded btn-primary">
                        <span className=" text-white me-2">
                            <i className="fa fa-search color-warning">
                            </i>
                        </span>{searchText}</button>
                }
                {save &&
                    <button type="button" name={id}
                        ref={ref => (inputrefs ? inputrefs.current[id] = ref : null)}
                        onClick={handleSubmit}
                        className="btn btn-rounded btn-success">
                        <span className=" text-white me-2">
                            {saveicon ? <i className={saveicon}></i> : <i className="fa">&#xf0c7;</i>}
                        </span>{savetext}</button>
                }
                {update &&
                    <button type="button" name={id}
                        onClick={handleSubmit}
                        className="btn btn-rounded btn-success">
                        <span className=" text-white me-2">
                            <i className="fa fa-upload color-warning">
                            </i>
                        </span>Update</button>
                }
                {Export &&
                    <button type="button" className="btn btn-rounded btn-warning" name={id}
                        onClick={handleExport}
                    ><span className=" text-warning me-2"><i className="fa fa-download text-white color-success"></i>
                        </span>Export</button>
                }
                {Reset &&
                    <button type="button" name={id} onClick={handleClear} className="btn btn-rounded btn-danger"><span className="text-white me-2"><i className="fa-solid fa-arrow-rotate-left"></i>
                    </span>Reset</button>}
                {children}
            </div>
        </div>
    )
}

export const ImportButton = ({ BulkSubmit, handleBulk, downloadFormat, children, Status = [], ErrorData, fileName = '' }) => {
    return (
        <div className='p-2 w-100' style={{ 'borderRadius': '8px', border: '1px dashed var(--border-color)' }}>
            <label className="form-label p-2">{'Bulk Upload'}
                <span style={{ color: "red" }}> *</span>
            </label>
            <FileUploader classes='file-uploader bulk-upload'
                handleChange={BulkSubmit}
                types={["xlsx"]}
                children={<FileUploadChild label='' message={fileName} types={["xlsx"]} />}
            />
            <div className='mt-2'>
                {/*<button type="button" className="btn btn-rounded btn-warning me-2 mb-0" style={{ minWidth: '8px' }} onClick={handleBulk}>*/}
                {/*    <i className="fa fa-upload text-white color-success"></i> Upload*/}
                {/*</button>*/}
                <span type="button" style={{ minWidth: '8px', textDecoration: 'underline', color: 'var(--blue)', fontSize: '13px' }} onClick={downloadFormat}>
                    Download Format <i className="fa fa-download color-success"></i>
                </span>
            </div>
            <div className='d-flex mb-1'>
                {Status?.length !== 0 ?
                    <>
                        <div className='text-success p-0 pt-2 m-0 fw-bold' style={{ lineHeight: '14px' }}>Success : {Status?.SuccessCount} &nbsp; &nbsp;
                            <span className='text-danger'>Error : {Status?.ErrorCount}
                                {Status?.length !== 0 && Status?.ErrorData?.length !== 0 ?
                                    <>&nbsp;<i className="fa fa-download  color-success" style={{ cursor: 'pointer' }} onClick={ErrorData}></i></>
                                    : ""}
                            </span></div>
                    </>
                    : ""}
            </div>
            {children}
        </div>
    )
}

export const InputBox = (props) => {
    let { divclassname = 'col-md-3 mb-1 cntrl-width ', renderinput = null, key = '', labelclass = 'form-label', titleInfo = '', onKeyDown = null, inputclassname = 'form-control', type = 'text', divstyle = null, inputstyle = null, inputrefs, id, label = '', value, onChange, placeholder, required } = props
    return (
        <div
            className={`${divclassname}`}
            style={divstyle}
            key={key}
        >
            {label !== '' ? <label style={{ 'whiteSpace': 'nowrap' }} className={labelclass} htmlFor={id}>{label}
                {required ? <span style={{ color: "red" }}> *</span> : <></>}
                {titleInfo && <PopupWithIcon InfoDetails={titleInfo} />}
            </label> : <></>}
            <input
                id={id}
                style={inputstyle}
                onKeyDown={onKeyDown}
                ref={ref => (inputrefs.current[id] = ref)}
                type={type}
                className={`${inputclassname}`}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                autoComplete="off"
                format={type === 'date' ? "dd-MMM-yyyy" : ''}
                title={required ? 'Please fill this field.' : ''}
                {...props}
            />
            {renderinput}


        </div>
    )
}
export const InputGroupBox = (props) => {
    const { divclassname = 'col-md-3 mb-1 cntrl-width', inputclassname = 'form-control', name, id, maxLength, inputstyle, disabled, onKeyDown, onChange, onClick, pattern, type, value, placeholder, label, required, startBoxClass, startIcon, startText, handleStartButtonClick, endBoxClass, endIcon, endText, handleEndButtonClick, inputrefs } = props;

    return (
        <>
            <div className={`Input_Group ${divclassname}`}>
                {label !== "" && label && <label style={{ 'whiteSpace': 'nowrap' }} className="form-label" title={label}>{label}
                    {required && <span className="text-danger"> *</span>}</label>
                }
                <div className={`main_div active`}>
                    {(startIcon || startText) && <div className={`input_start_box arrow${startBoxClass}`} onClick={() => handleStartButtonClick()}>
                        <span className="input_start_text text-truncate px-1">
                            {startIcon && <i className={startIcon} />}{startText && <sapn className='text-truncate' title={startText}>{startText}</sapn>}
                        </span>
                    </div>}

                    <input
                        onClick={onClick}
                        className={`${inputclassname}`}
                        name={name}
                        id={id}
                        ref={ref => (inputrefs.current[id] = ref)}
                        maxLength={maxLength}
                        style={inputstyle}
                        disabled={disabled}
                        onKeyDown={onKeyDown}
                        onChange={onChange}
                        pattern={pattern}
                        type={type ? type : "text"}
                        value={value}
                        placeholder={placeholder}
                        autoComplete="off"
                    />
                    {(endIcon || endText) && <div className={`input_end_box arrow ${endBoxClass}`} onClick={() => handleEndButtonClick()}>
                        <span className="input_end_text text-truncate px-1">
                            {endIcon && <i className={`${endIcon} mx-1`} />}{endText && <sapn className='text-truncate' title={endText}>{endText}</sapn>}
                        </span>
                    </div>}
                </div>
            </div>


        </>

    )
}
export const AutoCompleteBoxNew = (props) => {
    const { divclassname = 'col-md-3 mb-1 cntrl-width', onKeyDown, style, divstyle, inputstyle, inputrefs, maxLength, label = '', nextFocus = ''
        , placeholder, required, value, autocompleteType = '', contextKey = '', contextKey2 = '', contextKey3 = '', contextKey4 = '', contextKey5 = '', renderinput = null,
        Options, onfocusevent = false, isLocalOption = false, ...restProps } = props;

    const { id, multiple = false } = restProps

    const autoCompleteTimeoutRef = useRef(null);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [inputValue, setInputValue] = useState(value);
    useEffect(() => {
        setInputValue(value);
    }, [value]);

    const commonData = CommonApiData()
    let Data = {
        "authToken": commonData.AuthToken,
        "loginToken": commonData.LoginToken,
        "userCode": commonData.UserCode,
    };
    const handleAutoCompleteChange = (event, prefix) => {
        if (isLocalOption) {
            setAutoCompleteOptions(Options ? Options : []);
        } else {
            if (autoCompleteTimeoutRef.current) {
                clearTimeout(autoCompleteTimeoutRef.current);
            }
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData(Data, prefix, autocompleteType, contextKey, contextKey2, contextKey3, contextKey4, contextKey5);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay);
        }
    };

    const handleKeyDown = (event, currentKey) => { //auto focus on next input
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent form submission
            if (inputrefs && inputrefs.current && inputrefs.current !== undefined) {
                const keys = Object.keys(inputrefs.current);
                const currentIndex = keys.indexOf(currentKey);
                const nextIndex = (currentIndex + 1) % keys.length;
                let nextKey = keys[nextIndex];
                if (nextFocus && nextFocus !== "" && nextFocus !== undefined) {
                    nextKey = nextFocus;
                }
                if (inputrefs.current[nextKey]) {
                    inputrefs.current[nextKey].focus();
                }
            }
        }
    };

    return (
        <div
            className={`${divclassname}`}
            style={style || divstyle}
        >
            {label === '' ? '' :
                <label className="form-label" htmlFor={id}>{label || ''}
                    {required ? <span style={{ color: "red" }}> *</span> : <></>}
                </label>
            }
            <Autocomplete
                value={inputValue}
                freeSolo
                multiple={multiple}
                autoComplete
                autoSelect
                autoHighlight={inputValue ? false : true} // auto highlight first option
                selectOnFocus={true} // auto select all input text like jquery select
                includeInputInList
                filterOptions={(x) => x} // for accepting every input like (.)
                options={autoCompleteOptions}
                isOptionEqualToValue={(option, value) => multiple && option === value} // auto select option when set value from state
                onInputChange={
                    (event, newInputValue, reason) => {
                        if (reason && newInputValue && reason === 'input') {
                            handleAutoCompleteChange(event, newInputValue);
                        }
                        else {
                            if (autoCompleteOptions) {
                                setAutoCompleteOptions([]);
                            }
                        }
                    }}
                onClose={(event, reason) => {
                    if (autoCompleteOptions) {
                        setAutoCompleteOptions([]);

                    }
                }}
                onOpen={(event) => {
                    if (onfocusevent) {
                        handleAutoCompleteChange(event, '.');
                    }
                }}
                openOnFocus={true}
                title={required ? 'Please fill this field.' : ''}
                renderInput={(params) => <TextField
                    {...params}
                    onInput={(e) => {
                        const { value } = e.target;
                        if (value.length > maxLength) {
                            e.target.value = value.slice(0, maxLength);  //for max length of input
                        }
                    }}
                    inputRef={ref => (inputrefs.current[id] = ref)}
                    sx={inputstyle}
                    placeholder={placeholder}
                    onKeyDown={onKeyDown}
                    autoComplete="off"
                />}
                {...restProps}
            />
            {renderinput}
        </div>
    )
}


export const AutoCompleteBox = (props) => {
    const { setOptions, ...restProps } = props;

    const { divclassname = 'col-md-3 mb-1 cntrl-width', onKeyPress, onKeyDown, style, divstyle, inputstyle, inputrefs, maxLength, id, label = '', options, inputValue, onInputChange, placeholder, required } = restProps

    return (
        <div
            className={`${divclassname}`}
            style={style || divstyle}
        >
            {label === '' ? '' :
                <label className="form-label" htmlFor={id}>{label || ''}
                    {required ? <span style={{ color: "red" }}> *</span> : <></>}
                </label>
            }
            <Autocomplete
                freeSolo
                value={inputValue}
                inputValue={inputValue}
                onInputChange={onInputChange}
                filterOptions={(x) => x}
                options={options ? options : []}
                onClose={(event, reason) => {
                    if (setOptions) {
                        setOptions([]);
                    }
                }}
                autoHighlight={true}
                selectOnFocus={true}
                title={required ? 'Please fill this field.' : ''}
                renderInput={(params) => <TextField
                    {...params}
                    onInput={(e) => {
                        const { value } = e.target;
                        if (value.length > maxLength) {
                            e.target.value = value.slice(0, maxLength);
                        }
                    }}
                    inputRef={ref => (inputrefs.current[id] = ref)}
                    sx={inputstyle}
                    placeholder={placeholder}
                    onKeyPress={onKeyPress}
                    onKeyDown={onKeyDown}
                    autoComplete="off"
                />}
                {...restProps}
            />
        </div>
    )
}

export const DateBox = (props) => {
    const { divclassname = 'col-md-3 mb-1 cntrl-width', datepikerclass = '', labelstyle, style, inputstyle, label = '', onKeyDown, selected, placeholder, id, inputrefs, onChange, required } = props
    const validDateInput = function (e) {
        e.target.value = "";
    };
    return (
        <div
            className={`${divclassname}`}
            style={style}
        >
            {label === '' ? '' :
                <label className="form-label" style={labelstyle}>{label}
                    {required ? <span style={{ color: "red" }}> *</span> : <></>}

                </label>
            }
            <DatePicker
                className={`form-control input-fields ${datepikerclass}`}
                style={inputstyle}
                dateFormat="dd-MMM-yyyy"
                placeholderText={placeholder}
                selected={selected}
                ref={ref => (inputrefs.current[id] = ref?.input)}
                onKeyDown={onKeyDown}
                // inputrefs={inputrefs.current[id]}
                //isClearable={true}
                //selectsRange={true}
                //monthsShown={3 }
                // onMonthChange={() => { }}
                showYearDropdown={true}
                showMonthDropdown={true}
                //  selectsStart={true }
                //inline={true }
                //showIcon={true }
                //autoFocus={true }
                //closeOnScroll={true}
                // showFullMonthYearPicker={true }
                //  showTwoColumnMonthYearPicker={true }
                // onDayMouseEnter
                // focusSelectedMonth={true }
                //todayButton={true }
                onChangeRaw={(e) => validDateInput(e)}
                yearDropdownItemNumber={100}
                scrollableYearDropdown={true}
                preventOpenOnFocus={true}
                onChange={onChange}
                autoComplete="off"
                title={required ? 'Please fill this field.' : ''}
                {...props}
            />
        </div>
    )
}

export const SelectInputBox = (props) => {
    const { divclassname = 'col-md-3 mb-1 cntrl-width', inputclassname = '', onKeyDown, divstyle, inputstyle, inputrefs, id, label = '', value = '', onChange, children, required = false } = props
    return (
        <div
            className={` ${divclassname}`}
            style={divstyle}
        >
            {label === '' ? '' :
                <label className="form-label" style={{ textWrap: "nowrap" }} htmlFor={id}>{label || 'Branch'}
                    {required ? <span style={{ color: "red" }}> *</span> : <></>}
                </label>}
            <select
                id={id}
                className={`form-select ${inputclassname}`}
                style={inputstyle}
                onKeyDown={onKeyDown}
                ref={ref => (inputrefs.current[id] = ref)}
                value={value}
                onChange={onChange}
                title={required ? 'Please select an item in the list.' : ''}
                autoComplete="off"
                {...props}
            >
                {children}
            </select>
        </div>
    )
}

export const Switch = (props) => {
    const { id, checked = false, inputrefs, onKeyDown, label, extraclassname = 'form-check form-switch ps-4  mt-3 me-2', onChange, divclassname = 'col-md-3 mb-1  cntrl-width' } = props
    return (
        <div className={` ${divclassname}`} key={`checkin${id}`}>
            <div className={`${extraclassname}`} >
                <input
                    className="form-check-input"
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    ref={ref => (inputrefs.current[id] = ref)}
                    {...props}
                />
                <label className="form-check-label ms-2" style={{ textWrap: "nowrap" }} htmlFor={id}>{label}</label>
            </div>
        </div>
    )
}

export const CheckBoxInput = (props) => {
    const { id, checked = false, maindivclassname = 'col-md-4 col-lg-3 col-6 mb-1 cntrl-width', divclassname = `form-check form-switch ps-4 ps-md-5 mt-3`, labelclassname = "form-check-label ms-2", inputrefs, onKeyDown, label = '', onChange } = props
    return (
        <div className={maindivclassname} key={`checkin${id}`}>
            <div className={divclassname}>
                <input
                    className=""
                    type="checkbox"
                    id={id}
                    checked={checked}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    ref={ref => (inputrefs.current[id] = ref)}
                    {...props}
                />
                {label !== '' && <label className={labelclassname} htmlFor={id}>{label}</label>}
            </div>
        </div>
    )
}

export const MessageBoxAlert = React.memo(({ Msg = '', clearMessage, Status, uniqueId }) => {
    const audio = useMemo(() => new Audio(Status !== 'SUCCESS' ? './Sound/Error.mp3' : './Sound/Success.mp3'), [Status]);

    const handleClearMessage = useCallback(() => {
        clearMessage();
    }, [clearMessage]);
    let enableNotificationSound = false;
    if (GetSession('localStorage', 'enableNotificationSound') === 'true') {
        enableNotificationSound = true;
    }
    else if (GetSession('localStorage', 'enableNotificationSound') === null) {
        enableNotificationSound = true;
    }
    if (Msg !== '' && uniqueId) {
        if (enableNotificationSound) {

            audio.play();
        }
    }

    return (
        <>
            {Msg === '' ? '' :
                <div className='container-fluid p-0 m-0 pt-1 '>
                    <div className='col-md-12 col-lg-12 col-12 px-3 py-2 rounded' style={{ background: Status !== 'SUCCESS' ? '#ff7070' : '#68d95b96', color: '#172b64', fontWeight: '500' }}>
                        {Msg}
                        <span style={{ float: 'right', cursor: 'pointer' }} onClick={handleClearMessage}>X</span>
                    </div>
                </div>
            }
        </>
    );
});


export const TimeBox = (props) => {
    let { divclassname = 'col-md-3 mb-1 cntrl-width ', key = '', hideclock = true, labelclass = 'form-label', inputstyle, onKeyDown = null, inputclassname = '', divstyle = null, inputrefs, id, label = '', value, onChange, placeholder, required } = props

    const findFirstEnabledVisibleInput = (parent) => {
        if (!parent) return null;
        const isVisible = (elem) => !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
        const inputs = parent.querySelectorAll('input');
        for (let input of inputs) {
            if (!input.disabled && isVisible(input)) {
                return input;
            }
        }
        return null;
    };

    return (
        <div
            className={`${divclassname}`}
            style={divstyle}
        >
            {label !== '' ? <label style={{ 'whiteSpace': 'nowrap' }} className={labelclass} htmlFor={id}>{label}
                {required ? <span style={{ color: "red" }}> *</span> : <></>}
            </label> : <></>}
            <div
                ref={ref => {
                    const firstEnabledVisibleInput = findFirstEnabledVisibleInput(ref);
                    inputrefs.current[id] = firstEnabledVisibleInput;
                }}
                className='TimeBox'
                key={key}
            >
                <ReactTimePicker
                    value={value}
                    style={inputstyle}
                    onChange={onChange}
                    format="HH:mm"
                    clockIcon=''
                    placeholder={placeholder}
                    disableClock={hideclock}
                    autoComplete="off"
                    title={required ? 'Please fill this field.' : ''}
                    id={id}
                    onKeyDown={onKeyDown}
                    className={`form-control ${inputclassname}`}
                    {...props}
                />

            </div>
        </div>
    )
}

export const DragComponent = (paperProps) => (
    <Draggable
        handle="#alert-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
    >
        <div
            {...paperProps}
            style={{
                backgroundColor: 'white',
                boxShadow: 'none',
                minWidth: '400px',
                ...paperProps.style
            }}
        />
    </Draggable>
);